import { Action } from '@ngrx/store';

export const USER_LOGIN = '[User] User Login';
export const USER_LOGIN_SUCCESS = '[User] User Login Success';
export const USER_LOGIN_FAIL = '[User] User Login Fail';
export const USER_AUTO_LOGIN = '[User] User Auto Login';
export const USER_LOGIN_OAUTH = '[User] User Login Oauth';
export const USER_LOGIN_OAUTH_SUCCESS = '[User] User Login Oauth Success';
export const USER_LOGIN_OAUTH_FAIL = '[User] User Login Oauth Fail';

export class UserLogin implements Action {
  readonly type = USER_LOGIN;
  constructor(public payload: any) {}
}

export class UserLoginSuccess implements Action {
  readonly type = USER_LOGIN_SUCCESS;
  constructor(public payload: any) {}
}

export class UserLoginFail implements Action {
  readonly type = USER_LOGIN_FAIL;
  constructor(public payload: any) {}
}

export class UserAutoLogin implements Action {
  readonly type = USER_AUTO_LOGIN;
  constructor(public payload: string, public returnURL: string = '') {}
}

export class UserLoginOauth implements Action {
  readonly type = USER_LOGIN_OAUTH;
  constructor(public payload: any) {}
}

export class UserLoginOauthSuccess implements Action {
  readonly type = USER_LOGIN_OAUTH_SUCCESS;
  constructor(public payload: any) {}
}

export class UserLoginOauthFail implements Action {
  readonly type = USER_LOGIN_OAUTH_FAIL;
}

export const USER_VIEW_LOCAL = '[User] User View Local';
export const USER_VIEW_LOCAL_SUCCESS = '[User] User View Local Success';
export const USER_VIEW_LOCAL_FAIL = '[User] User View Local Fail';

export class UserViewLocal implements Action {
  readonly type = USER_VIEW_LOCAL;
}

export class UserViewLocalSuccess implements Action {
  readonly type = USER_VIEW_LOCAL_SUCCESS;
  constructor(public payload: any) {}
}

export class UserViewLocalFail implements Action {
  readonly type = USER_VIEW_LOCAL_FAIL;
  constructor(public payload: any) {}
}

export const USER_LOGOUT = '[User] User Logout';
export const USER_LOGOUT_SUCCESS = '[User] User Logout Success';
export const USER_LOGOUT_FAIL = '[User] User Logout Fail';

export class UserLogout implements Action {
  readonly type = USER_LOGOUT;
}

export class UserLogoutSuccess implements Action {
  readonly type = USER_LOGOUT_SUCCESS;
}

export class UserLogoutFail implements Action {
  readonly type = USER_LOGOUT_FAIL;
}

export const USER_REFRESH_ACCESS_TOKEN = '[User] User Refresh Access Token';
export const USER_REFRESH_ACCESS_TOKEN_SUCCESS = '[User] User Refresh Access Token Success';
export const USER_REFRESH_ACCESS_TOKEN_FAIL = '[User] User Refresh Access Token Fail';

export class UserRefreshAccessToken implements Action {
  readonly type = USER_REFRESH_ACCESS_TOKEN;
}

export class UserRefreshAccessTokenSuccess implements Action {
  readonly type = USER_REFRESH_ACCESS_TOKEN_SUCCESS;
  constructor(public payload: any) {}
}

export class UserRefreshAccessTokenFail implements Action {
  readonly type = USER_REFRESH_ACCESS_TOKEN_FAIL;
}

export type UserAction =
  | UserLogin
  | UserLoginSuccess
  | UserLoginFail
  | UserLoginOauth
  | UserLoginOauthSuccess
  | UserLoginOauthFail
  | UserViewLocal
  | UserViewLocalSuccess
  | UserViewLocalFail
  | UserLogout
  | UserLogoutSuccess
  | UserLogoutFail
  | UserRefreshAccessToken
  | UserRefreshAccessTokenSuccess
  | UserRefreshAccessTokenFail;
